import { Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { API } from "aws-amplify";

import SelectTool from "components/tools/SelectTool";
import { serviceOrderToolsByServiceOrderId } from "graphql/queries";
import {
  createServiceOrderTool,
  deleteServiceOrderTool,
} from "graphql/mutations";

const ToolsCard = ({ serviceOrder }) => {
  const [initialTools, setInitialTools] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeTools = async (tools) => {
    try {
      setInitialTools(tools);

      const promises = [];

      // Update tools
      const toolsToUnLink = initialTools?.filter(
        (servTool) => !tools?.some((tool) => tool === servTool)
      );
      toolsToUnLink?.forEach(async (toolId) => {
        const records = (
          await API.graphql({
            query: serviceOrderToolsByServiceOrderId.replaceAll(
              "__typename",
              ""
            ),
            variables: {
              serviceOrderId: serviceOrder.id,
              filter: {
                and: [{ toolId: { eq: toolId } }],
              },
            },
          })
        )?.data?.serviceOrderToolsByServiceOrderId?.items;
        promises.push(
          API.graphql({
            query: deleteServiceOrderTool.replaceAll("__typename", ""),
            variables: {
              input: {
                id: records[0].id,
              },
            },
          })
        );
      });
      const toolsToLink = tools?.filter(
        (tool) => !initialTools?.some((rec) => rec === tool)
      );
      toolsToLink?.forEach((toolId) => {
        promises.push(
          API.graphql({
            query: createServiceOrderTool.replaceAll("__typename", ""),
            variables: {
              input: {
                toolId,
                serviceOrderId: serviceOrder.id,
              },
            },
          })
        );
      });

      await Promise.all(promises);
    } catch (err) {
      toast.error(strings.responses.errorRequest);
    }
  };

  const fetchToolsByService = async (serviceOrderId) => {
    try {
      setLoading(true);

      const records = (
        await API.graphql({
          query: serviceOrderToolsByServiceOrderId.replaceAll("__typename", ""),
          variables: {
            serviceOrderId,
          },
        })
      )?.data?.serviceOrderToolsByServiceOrderId?.items;

      setInitialTools(records?.map((r) => r.toolId) ?? []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceOrder?.id) fetchToolsByService(serviceOrder.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceOrder?.id]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5 text-muted">{strings.tools.title}</span>
        {loading ? (
          <Loader />
        ) : (
          <SelectTool
            initialValues={initialTools}
            executor={serviceOrder.userExecutor}
            onChangeTools={onChangeTools}
            companyID={serviceOrder.companyID}
          />
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    tools: {
      title: "Herramientas",
    },
    responses: {
      errorFetch: "Error al consultar herramientas",
      errorRequest: "Error al realizar la petición",
    },
  },
});

export default ToolsCard;
